export default "__VITE_ASSET__36031524__"